var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJapan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 15.1111C21 15.6022 20.6084 16 20.125 16H0.875C0.391562 16 0 15.6022 0 15.1111V0.888889C0 0.397778 0.391562 0 0.875 0H20.125C20.6084 0 21 0.397778 21 0.888889V15.1111Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.4444C12.9162 12.4444 14.875 10.4546 14.875 7.99999C14.875 5.54539 12.9162 3.55554 10.5 3.55554C8.08375 3.55554 6.125 5.54539 6.125 7.99999C6.125 10.4546 8.08375 12.4444 10.5 12.4444Z",
    fill: "#BA0831"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapan);
export default __webpack_public_path__ + "static/media/japan.ae1be34e.svg";
export { ForwardRef as ReactComponent };